<template lang="pug">
  v-banner(
    :app="value"
    :value="value") {{ content }}
    template(
      v-if="action1 || action2"
      #actions)
      v-btn(
        v-if="action2"
        text
        @click="action2.onClick") {{ action2.label }}
      v-btn(
        v-if="action1"
        text
        @click="action1.onClick"
        color="primary") {{ action1.label }}
</template>

<script>
import { state } from '..'
import { toRefs } from '@vue/composition-api'

import { VBanner, VBtn } from 'vuetify/lib'

export default {
  components: {
    VBanner, VBtn
  },

  setup () {
    return {
      ...toRefs(state)
    }
  }
}
</script>

